import React from 'react';

import cs from 'classnames';

const EnrollmentStatusBadge = ({ isEnrolled }) => {
  return (
    <span
      style={{ border: '1px solid rgba(0, 0, 0, 0.12)' }}
      className={cs(
        'inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium text-neutral-900',
        isEnrolled ? 'bg-success-100' : 'bg-danger-100'
      )}>
      <span
        className={cs('h-1.5 w-1.5 rounded-full', isEnrolled ? 'bg-success-600' : 'bg-danger-600')}
      />
      {isEnrolled ? 'Enrolled' : 'Not enrolled'}
    </span>
  );
};

export default EnrollmentStatusBadge;
